import { Outlet } from "react-router";
import ResponsiveDrawer from "./Sidebar";

const Layout = () => {
  return (
    <div className="main">
      <ResponsiveDrawer />
      <div className="layoutmain">
        <Outlet />
      </div>
    </div>
  );
};

export default Layout;
